import React from "react";
import Draggable, { DraggableData } from "react-draggable";

interface VideoTimelineProps {
    xPosition: number;
    xBoundary: number;
    onDrag(data: DraggableData): void;
    zIndex?: number;
    height: number;
}

export const VideoTimeline = (props: VideoTimelineProps): JSX.Element => {
    const { xPosition, onDrag, zIndex, xBoundary, height } = props;

    return (
        <Draggable
            axis="x"
            bounds={{ left: 0, right: xBoundary }}
            onDrag={(e, data) => onDrag(data)}
            position={{ x: xPosition, y: 0 }}
        >
            <div
                style={{
                    position: "absolute",
                    zIndex: zIndex ?? 2,
                    width: "2px",
                    height,
                    backgroundColor: "#0076EC",
                    cursor: "grab"
                }}
            ></div>
        </Draggable>
    );
};
